'use client';

import dynamic from 'next/dynamic';

export const ClientModalProvider = dynamic(
  () =>
    import('./client-modal-provider').then((mod) => mod.ClientModalProvider),
  { ssr: false }
);
